import * as _ from 'lodash';
import * as moment from 'moment';
import { Component } from 'react';
import { AppActionCreators, IApplicationState, CenterActionCreators, IOptnSrtrMonthlyDataResponse, IUpdateOptnSrtrData, IOptnSrtrMonthlyDataAddResponse, IAppState } from '@nkr/store/index';
import { connect, Dispatch } from 'react-redux';
import { IBaseResponse, ICenterBase, ICenterUnosDataMonthlyWithStatus } from '@nkr/models/index';
import { AxiosError } from 'axios';
import MonthlyData from './monthly-data';
import AddData from './add-data';
import ConfirmDelete from './confirm-delete';
import { GridApi, GridReadyEvent, RowSelectedEvent } from 'ag-grid-community';

interface IProps {
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getMonthlyData: () => Promise<IOptnSrtrMonthlyDataResponse>,
    updateData: (data: IUpdateOptnSrtrData[]) => Promise<IBaseResponse>,
    addData: (data: IUpdateOptnSrtrData) => Promise<IOptnSrtrMonthlyDataAddResponse>,
    deleteData: (list: number[]) => Promise<IBaseResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    data: ICenterUnosDataMonthlyWithStatus[],
    centers: ICenterBase[],
    showAdd: boolean,
    // showDeleteButton: boolean,
    showDeleteConfirm: boolean,
    loadingData: boolean,
    gridApi: GridApi
}

class AdminCenterUnosData extends Component<TProps, IState> {
    readonly state: IState = {
        data: [],
        centers: [],
        showAdd: false,
        // showDeleteButton: false,
        showDeleteConfirm: false,
        loadingData: true,
        gridApi: null
    };

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api
        });
    }

    // onRowSelected = (e: RowSelectedEvent) => {
    //     let rows = e.api.getSelectedNodes().filter(x => x.isSelected());

    //     this.setState({
    //         showDeleteButton: rows.length > 0
    //     });
    // }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting UNOS data, one moment please...').then(() => {
            this.props.getMonthlyData().then(response => {
                if (response.data.success) {
                    let { data, centers } = response.data.results;

                    let d = data.map(x => {
                        let ddTxpsOriginal = x.ddTxps;
                        let ldTxpsOriginal = x.ldTxps;
                        let wlTotalOriginal = x.wlTotal;
                        let wlActiveOriginal = x.wlActive;

                        let ldaOriginal = x.lda;
                        let ldbOriginal = x.ldb;
                        let ldabOriginal = x.ldab;
                        let ldoOriginal = x.ldo;

                        let ldraOriginal = x.ldra;
                        let ldrbOriginal = x.ldrb;
                        let ldrabOriginal = x.ldrab;
                        let ldroOriginal = x.ldro;

                        return {
                            ...x,
                            ddTxpsOriginal, ldTxpsOriginal, wlTotalOriginal, wlActiveOriginal,
                            ldaOriginal, ldbOriginal, ldabOriginal, ldoOriginal,
                            ldraOriginal, ldrbOriginal, ldrabOriginal, ldroOriginal,
                            status: 0,
                            selected: false
                        };
                    });

                    this.setState({
                        data: d,
                        centers,
                        loadingData: false
                    }, () => {
                        this.props.hideLoading();
                    });
                }
            });
        });
    }

    getSelectedData = () => {
        let selectedRows = this.state.gridApi != null ? this.state.gridApi.getSelectedRows() as ICenterUnosDataMonthlyWithStatus[] : [];
        return _.orderBy(selectedRows, x => moment(x.date, 'MM-YYYY'));
    }

    handleDataChanged = (id: number, property: string, value: string) => {
        let data = _.cloneDeep(this.state.data).map(x => {
            if (x.id == id) {
                x[property] = value;

                let hasChanged =
                    x.ddTxps != x.ddTxpsOriginal
                    || x.ldTxps != x.ldTxpsOriginal
                    || x.wlTotal != x.wlTotalOriginal
                    || x.wlActive != x.wlActiveOriginal

                    || x.lda != x.ldaOriginal
                    || x.ldb != x.ldbOriginal
                    || x.ldab != x.ldabOriginal
                    || x.ldo != x.ldoOriginal

                    || x.ldra != x.ldraOriginal
                    || x.ldrb != x.ldrbOriginal
                    || x.ldrab != x.ldrabOriginal
                    || x.ldro != x.ldroOriginal
                    ;

                if (hasChanged) {
                    x.status = 1;
                } else {
                    x.status = 0;
                }
            }

            return x;
        });

        this.setState({
            data
        });
    }

    handleRevertChanges = (id: number) => {
        let data = _.cloneDeep(this.state.data).map(x => {
            if (x.id == id) {
                x.ddTxps = x.ddTxpsOriginal;
                x.ldTxps = x.ldTxpsOriginal;
                x.wlTotal = x.wlTotalOriginal;
                x.wlActive = x.wlActiveOriginal;

                x.lda = x.ldaOriginal;
                x.ldb = x.ldbOriginal;
                x.ldab = x.ldabOriginal;
                x.ldo = x.ldoOriginal;

                x.ldra = x.ldraOriginal;
                x.ldrb = x.ldrbOriginal;
                x.ldrab = x.ldrabOriginal;
                x.ldro = x.ldroOriginal;

                x.status = 0;
            }

            return x;
        });

        this.setState({
            data
        });
    }

    handleShowAdd = () => {
        this.setState({
            showAdd: true
        });
    }

    handleSaveAdd = (centerId: string, dataDate: string, ddTxps: string, ldTxps: string, wlTotal: string, wlActive: string, lda: string, ldb: string, ldab: string, ldo: string, ldra: string, ldrb: string, ldrab: string, ldro: string) => {
        this.setState({
            showAdd: false
        }, () => {
            let data: IUpdateOptnSrtrData = {
                id: 0,
                centerId: parseInt(centerId),
                dataDate,

                ddTxps,
                ldTxps,
                wlTotal,
                wlActive,

                lda,
                ldb,
                ldab,
                ldo,

                ldra,
                ldrb,
                ldrab,
                ldro
            };

            this.props.showLoading('Saving new center data, one moment please...')
                .then(() => {
                    this.props.addData(data).then(response => {
                        if (response.data.success) {
                            let {
                                ddTxps: ddTxpsOriginal, ldTxps: ldTxpsOriginal, wlTotal: wlTotalOriginal, wlActive: wlActiveOriginal,
                                lda: ldaOriginal, ldb: ldbOriginal, ldab: ldabOriginal, ldo: ldoOriginal,
                                ldra: ldraOriginal, ldrb: ldrbOriginal, ldrab: ldrabOriginal, ldro: ldroOriginal
                            } = response.data.results;

                            let data = _.cloneDeep(this.state.data);

                            data.push({
                                ...response.data.results,
                                ddTxpsOriginal, ldTxpsOriginal, wlTotalOriginal, wlActiveOriginal,
                                ldaOriginal, ldbOriginal, ldabOriginal, ldoOriginal,
                                ldraOriginal, ldrbOriginal, ldrabOriginal, ldroOriginal,
                                status: 0,
                                selected: false
                            });

                            this.setState({
                                data
                            }, () => {
                                this.props.hideLoading();
                            });
                        }
                    });
                })
                .catch((error: AxiosError) => {
                    this.setState({
                        // error: {
                        //     show: true,
                        //     message: error.message
                        // }
                    });
                });
        });
    }

    handleCancelAdd = () => {
        this.setState({
            showAdd: false
        });
    }

    handleShowDeleteConfirm = () => {
        this.setState({
            showDeleteConfirm: true
        });
    }

    handleDeletedSelectedRows = () => {
        let list = this.getSelectedData().map(x => x.id);

        this.props.showLoading('Deleting selected records, one moment please...')
            .then(() => {
                this.props.deleteData(list).then(response => {
                    let data = _.cloneDeep(this.state.data).filter(x => list.indexOf(x.id) < 0);

                    this.setState({
                        data,
                        showDeleteConfirm: false
                    }, () => {
                        this.props.hideLoading();
                    });
                })
                    .catch((error: AxiosError) => {
                        // this.setState({
                        //     error: {
                        //         show: true,
                        //         message: error.message
                        //     }
                        // });
                    });
            });
    }

    handleDeleteConfirmCancel = () => {
        this.setState({
            showDeleteConfirm: false
        });
    }

    handleSavePendingChanges = () => {
        let pendingChanges = this.state.data.filter(x => x.status > 0).map(x => {
            let { id, cId, date, ddTxps, ldTxps, wlTotal, wlActive, lda, ldb, ldab, ldo, ldra, ldrb, ldrab, ldro } = x;

            return {
                id,
                centerId: cId,
                dataDate: moment(date, 'MM-YYYY').format(),

                ddTxps,
                ldTxps,
                wlTotal,
                wlActive,

                lda,
                ldb,
                ldab,
                ldo,

                ldra,
                ldrb,
                ldrab,
                ldro
            };
        });

        this.state.gridApi.stopEditing();

        this.props.showLoading('Updating data, one moment please...').then(() => {
            this.props.updateData(pendingChanges).then(x => {
                let data = _.cloneDeep(this.state.data).map(x => {
                    x.ddTxpsOriginal = x.ddTxps;
                    x.ldTxpsOriginal = x.ldTxps;
                    x.wlTotalOriginal = x.wlTotal;
                    x.wlActiveOriginal = x.wlActive;

                    x.ldaOriginal = x.lda;
                    x.ldbOriginal = x.ldb;
                    x.ldabOriginal = x.ldab;
                    x.ldoOriginal = x.ldo;

                    x.ldraOriginal = x.ldra;
                    x.ldrbOriginal = x.ldrb;
                    x.ldrabOriginal = x.ldrab;
                    x.ldroOriginal = x.ldro;

                    x.status = 0

                    return x;
                });

                this.setState({
                    data
                }, () => {
                    this.props.hideLoading();
                });
            });
        });
    }

    render = () => {
        const deleteData = this.getSelectedData();

        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: 30, marginBottom: 20 }}>
                    <div style={{ flexBasis: '33%', fontSize: 28, fontWeight: 500, display: 'flex', alignItems: 'center' }}>
                        CENTER UNOS Data
                    </div>
                </div>

                <MonthlyData
                    data={this.state.data}
                    centers={this.state.centers}
                    gridHeight='80vh'
                    loading={this.state.loadingData}
                    isCenter={false}
                    onGridReady={this.onGridReady}
                    onDataChanged={this.handleDataChanged}
                    onSavePendingChanges={this.handleSavePendingChanges}
                    onAddData={this.handleShowAdd}
                    onDeleteData={this.handleShowDeleteConfirm}
                />

                <AddData
                    show={this.state.showAdd}
                    centers={this.state.centers}
                    centerId={0}
                    showCenter={true}
                    onSave={this.handleSaveAdd}
                    onCancel={this.handleCancelAdd}
                />

                <ConfirmDelete
                    show={this.state.showDeleteConfirm}
                    data={deleteData}
                    isCenter={false}
                    onDelete={this.handleDeletedSelectedRows}
                    onCancel={this.handleDeleteConfirmCancel}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getMonthlyData: () => {
            return dispatch(CenterActionCreators.getOptnSrtrMonthlyData());
        },
        updateData: (data) => {
            return dispatch(CenterActionCreators.updateOptnSrtrData(data));
        },
        addData: (data) => {
            return dispatch(CenterActionCreators.addOptnSrtrData(data));
        },
        deleteData: (list) => {
            return dispatch(CenterActionCreators.deleteOptnSrtrData(list));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(AdminCenterUnosData);